var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-description"},[_c('h2',{staticClass:"h1 my-3"},[_vm._v(_vm._s(_vm.headline))]),_c('p',[_vm._v(" "+_vm._s(_vm.paragraph)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }